import { render, staticRenderFns } from "./TipsComponent.vue?vue&type=template&id=c4046414&scoped=true&"
import script from "./TipsComponent.vue?vue&type=script&lang=js&"
export * from "./TipsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4046414",
  null
  
)

export default component.exports